import Head from 'next/head';

export const JsonLdScript: React.FC<{ id: string; data: Record<string, unknown> }> = ({ id, data }) => (
	<Head>
		{/* eslint-disable-next-line react/no-danger */}
		<script
			key={id}
			type="application/ld+json"
			// Escape "<" so a literal "</script>" inside string content (e.g. a bio) can't break out of the tag.
			dangerouslySetInnerHTML={{ __html: JSON.stringify(data).replace(/</g, '\\u003c') }}
		/>
	</Head>
);
